// extracted by mini-css-extract-plugin
export default {"setupLayout":"SetupLayout_setupLayout__4UdCC"};